export const ACTIVECART_DRAFTORDER_GET_REQUEST = 'ACTIVECART_DRAFTORDER_GET_REQUEST';
export const ACTIVECART_DRAFTORDER_GET_SUCCESS = 'ACTIVECART_DRAFTORDER_GET_SUCCESS';
export const ACTIVECART_DRAFTORDER_GET_ERROR = 'ACTIVECART_DRAFTORDER_GET_ERROR';
export const ACTIVECART_BESTCOUPON_GET_REQUEST = 'ACTIVECART_BESTCOUPON_GET_REQUEST';
export const ACTIVECART_BESTCOUPON_GET_SUCCESS = 'ACTIVECART_BESTCOUPON_GET_SUCCESS';
export const ACTIVECART_BESTCOUPON_GET_ERROR = 'ACTIVECART_BESTCOUPON_GET_ERROR';
export const ACTIVECART_APPLY_BESTCOUPON_POST_REQUEST = 'ACTIVECART_APPLY_BESTCOUPON_POST_REQUEST';
export const ACTIVECART_TOGGLE_WIGGLE_EFFECT = 'ACTIVECART_TOGGLE_WIGGLE_EFFECT';
